import { z } from 'zod';
import { requiredIntFromNumberInput } from '@/shared/utils/formZod.schema.utils';

export const comarcaFormSchema = z
  .object({
    ordem: requiredIntFromNumberInput({
      requiredMessage: 'Informe a ordem',
      min: 0,
      minMessage: 'A ordem deve ser zero ou maior',
    }),
    nome: z.string().trim().min(1, 'Informe o nome da comarca'),
    prefixo: z.string().trim().optional(),
    agrupar: z.boolean().optional(),
  })
  .passthrough();

export type ComarcaFormValues = z.infer<typeof comarcaFormSchema>;
